import { render, staticRenderFns } from "./SupportRequestDetailTable.vue?vue&type=template&id=4bbfa880&"
import script from "./SupportRequestDetailTable.vue?vue&type=script&lang=js&"
export * from "./SupportRequestDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./SupportRequestDetailTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports